export const LEAD_LANDLORDS_TYPE = 1;
export const LEAD_WBC_TYPE = 2;
export const LEAD_DAC_TYPE = 3;

export const CONTACT_TYPES = [
  { id: LEAD_LANDLORDS_TYPE, name: "LandLords" },
  { id: LEAD_WBC_TYPE, name: "WBC" },
  { id: LEAD_DAC_TYPE, name: "DAC" },
];